import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modulo } from 'src/app/modulos/modulo/modulo.component';
import { ModuloLogoModule } from './modulo-logo/modulo-logo.module';
import { ModuloContatoModule } from './modulo-contato/modulo-contato.module';
import { ModuloRedeSocialModule } from './modulo-rede-social/modulo-rede-social.module';
import { ModuloNewsletterModule } from './modulo-newsletter/modulo-newsletter.module';
import { BannerSliderSlickComponent } from 'src/app/modulos/banner-slider-slick/banner-slider-slick.component';import { FaleConoscoComponent } from 'src/app/modulos/fale-conosco/fale-conosco.component';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import { ProdutoPartialModule } from '../produto/produto-partial/produto-partial.module';
import { ModuloDestinosComponent } from 'src/app/modulos/modulo-destinos/modulo-destinos.component';
import { PipeModule } from '../pipe/pipe.module';
import { EnderecoComponent } from 'src/app/modulos/endereco/endereco.component';
import { ModuloWhatsappModule } from './modulo-whatsapp/modulo-whatsapp.module';
import { ModuloFaleConoscoModule } from './modulo-fale-conosco/modulo-fale-conosco.module';
import { ProdutoClassificacaoItemModule } from '../produto/produto-classificacao-item/produto-classificacao-item.module';
import { ProdutoEmbarcacaoItemModule } from '../produto/produto-embarcacao-item/produto-embarcacao-item.module';
import { BlogDestaqueComponent } from '../../modulos/blog/blog-destaque/blog-destaque.component';
import { BlogItemComponent } from '../../components/blog/blog-item/blog-item.component';
import { RouterModule } from '@angular/router';
import { MenuFooterComponent } from 'src/app/components/partial/menu-footer/menu-footer.component';
import { ContatoSuporteModuloComponent } from '../../modulos/contato-suporte-modulo/contato-suporte-modulo.component';
import { RedeSocialComponent } from 'src/app/modulos/rede-social/rede-social.component';
import { DestinosMenuModuloComponent } from '../../modulos/destinos-menu-modulo/destinos-menu-modulo.component';
import { ModulosDestaqueComponent } from 'src/app/components/modulo/modulos-destaque/modulos-destaque.component';
import { ProdutoCategoriaDestaqueComponent } from 'src/app/modulos/produto-categoria-destaque/produto-categoria-destaque.component';
import { ProdutoClassificacaoDestaqueComponent } from '../../modulos/produto-classificacao-destaque/produto-classificacao-destaque.component';
import { ProdutoBuscaComponent } from '../../modulos/produto-busca/produto-busca.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AvaliacaoComponent } from 'src/app/modulos/avaliacao/avaliacao.component';
import { ModuloBannerComponent } from 'src/app/modulos/modulo-banner/modulo-banner.component'; 
import { ProdutoSearchBannerComponent } from 'src/app/components/produto/produto-search-banner/produto-search-banner.component';
import { ComboDataSelectModule } from '../combo/combo-data-select/combo-data-select.module';
import { LoaderModule } from '../loader/loader/loader.module';
import { ModuloEventosModule } from './modulo-eventos/modulo-eventos.module';

@NgModule({
  declarations: [
    Modulo,
    BannerSliderSlickComponent,
    ModuloDestinosComponent,
    EnderecoComponent,
    BlogDestaqueComponent,
    BlogItemComponent,
    MenuFooterComponent,
    ContatoSuporteModuloComponent,
    RedeSocialComponent,
    DestinosMenuModuloComponent,
    ModulosDestaqueComponent,
    ProdutoCategoriaDestaqueComponent,
    ProdutoClassificacaoDestaqueComponent,
    ProdutoBuscaComponent,
    AvaliacaoComponent,
    ModuloBannerComponent,
    ProdutoSearchBannerComponent
  ],
  exports:[
    Modulo,
    BannerSliderSlickComponent,
    EnderecoComponent,
    BlogDestaqueComponent,
    MenuFooterComponent,
    ContatoSuporteModuloComponent,
    RedeSocialComponent,
    DestinosMenuModuloComponent,
    ModulosDestaqueComponent,
    ProdutoCategoriaDestaqueComponent,
    ProdutoClassificacaoDestaqueComponent,
    ProdutoBuscaComponent,
    AvaliacaoComponent,
    ModuloBannerComponent,
    ProdutoSearchBannerComponent
  ],
  imports: [
    RouterModule,
    ModuloFaleConoscoModule,
    ModuloWhatsappModule,  
    ProdutoPartialModule,
    LazyLoadImageModule,
    ModuloLogoModule, 
    ModuloContatoModule,
    ModuloRedeSocialModule,
    ModuloNewsletterModule,
    CommonModule,
    PipeModule,  
    ProdutoClassificacaoItemModule,
    ProdutoEmbarcacaoItemModule,
    ReactiveFormsModule,
    FormsModule,
    ComboDataSelectModule,
    LoaderModule,
    ModuloEventosModule
  ]
})
export class ModuloModule{}
